import React, {useState} from 'react';
import ModalContainer from "../../../../components/ModalContainer";
import TextButton from "../../../../components/common/TextButton";
import Button from "../../../../components/common/Button";
import styles from './styles.module.scss';
import {EnumChecklistTypes} from "../../../ChecklistPage";

interface IProps {
    title: EnumChecklistTypes;
    handleClose: () => void;
    handleEditFilter: (filterName: EnumChecklistTypes, value?: string) => void;
    initValue: string;
}

const ModalTextInputFilter = ({title, handleClose, handleEditFilter, initValue}: IProps) => {
    const [filter, setFilter] = useState(initValue);


    const handleChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFilter(value);
    };

    const handleSave = () => {
        handleEditFilter(title, filter);
        handleClose()
    }

    return (
        <ModalContainer handleClose={handleClose}>
            <div className={styles.modal}>
                <h2 className={styles.modal__subtitle}>
                    Filter {title}
                </h2>
                <input
                    autoFocus
                    className={styles.modal__input}
                    placeholder={'Search'}
                    value={filter}
                    onChange={handleChangeFilter}
                />
                <div className={styles.modal__footer}>
                    <div className={styles.modal__btn}>
                        <TextButton
                            text={'Cancel'}
                            onClick={handleClose}
                        />
                    </div>
                    <div className={styles.modal__btn}>
                        <Button
                            text={'Apply'}
                            onClick={handleSave}
                        />
                    </div>
                </div>
            </div>
        </ModalContainer>
    );
};

export default ModalTextInputFilter;
